import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { GlobalsService } from '@services/global.service';
import { DxAutocompleteComponent } from 'devextreme-angular';
import { BarcodeScannerComponent } from '@components/generic/barcode-scanner/barcode-scanner.component';
import { BarcodeLaserComponent } from '@components/generic/barcode-laser/barcode-laser.component';

export enum ScannerMode {
  Camera = 'camera',
  Laser = 'laser'
}

export interface IButtonConfig {
  text: string;
  onClick: (value: string) => void;
}

@Component({
  selector: 'app-barcode-input-widget',
  templateUrl: './barcode-input-widget.component.html',
  styleUrls: ['./barcode-input-widget.component.scss']
})
export class BarcodeInputWidgetComponent implements OnInit {
  public ScannerMode = ScannerMode;
  private readonly SCANNER_MODE_KEY = 'barcode_scanner_mode';

  @Input() public scannerMode: ScannerMode = ScannerMode.Camera;
  @Input() public scanIconPath = '../../../../assets/img/icons/photo.svg';
  @Input() public laserIconPath = '../../../../assets/img/icons/stock-mobile/scan-barcode.svg';
  @Input() public barcodeDataSource: unknown;
  @Input() public barcodeInput: string;
  @Input() public showBarcodeButton = false;
  @Input() public barcodeButton: IButtonConfig;
  @Input() public showBarcodeScanner = false;
  @Input() public scanOnlyBarcode = false;
  @Input() public showFloatingCameraButton = false;
  @Input() public showManualBarcodeInput = false;
  @Input() public withBottomNav = false;
  @Input() public showPanel = true;
  @Input() public showChooser = true;
  @Input() public showBarcodeImage = true;
  @Input() public showBarcodeInstruction = true;

  // Lookup section inputs
  @Input() public showLookupSection = true;
  @Input() public lookupDataSource: unknown;
  @Input() public lookupDisplayExpr = 'name';
  @Input() public lookupValueExpr = 'id';
  @Input() public lookupSearchExpr = 'name';
  @Input() public lookupPlaceholder = 'Search here';
  @Input() public lookupValue: unknown;

  // Event outputs
  @Output() public readonly scanPopupOpen = new EventEmitter<void>();
  @Output() public readonly barcodeSelected = new EventEmitter<unknown>();
  @Output() public readonly barcodeInputEnterKey = new EventEmitter<unknown>();
  @Output() public readonly lookupSelected = new EventEmitter<unknown>();
  @Output() public readonly scanSuccess = new EventEmitter<unknown>();
  @Output() public readonly scannerClose = new EventEmitter<void>();

  @ViewChild('barcodeAutoComplete', { static: false }) public barcodeAutoComplete: DxAutocompleteComponent;
  @ViewChild('barcodeScanner', { static: false }) public barcodeScanner: BarcodeScannerComponent;
  @ViewChild('laserScanner', { static: false }) public laserScanner: BarcodeLaserComponent;

  constructor(public globalsService: GlobalsService) { }

  public ngOnInit(): void {
    this.loadScannerModeFromStorage();
  }

  public openScanPopup(): void {
    if (this.scannerMode === ScannerMode.Camera) {
      this.scanPopupOpen.emit();
    }
  }

  public onBarcodeSelected(event: unknown): void {
    this.barcodeAutoComplete.instance.blur();
    this.barcodeSelected.emit(event);
  }

  public onBarcodeInputEnterKeyPress(event: unknown): void {
    this.barcodeAutoComplete.instance.blur();
    this.barcodeInputEnterKey.emit(event);
  }

  public onLookupSelected(event: unknown): void {
    this.lookupSelected.emit(event);
  }

  public scanSuccessHandler(event: unknown): void {
    this.scanSuccess.emit(event);
  }

  public scannerCloseHandler(): void {
    this.scannerClose.emit();
  }

  public showAssignBarcode(barcode: string): void {
    this.barcodeScanner.showAssignBarcode(barcode);
  }

  public enterKeyPressedHandler(): void { }

  public escapeKeyPressedHandler(): void {
    this.barcodeInput = '';
  }

  public setScannerMode(mode: ScannerMode): void {
    this.scannerMode = mode;
    localStorage.setItem(this.SCANNER_MODE_KEY, mode);
    this.barcodeInput = '';
    if (this.laserScanner) {
      this.laserScanner.resetScanBuffer();
    }

    if (mode === ScannerMode.Laser) {
      if (this.barcodeAutoComplete) {
        this.barcodeAutoComplete.instance.focus();
      }
    }
  }

  private loadScannerModeFromStorage(): void {
      const savedMode = localStorage.getItem(this.SCANNER_MODE_KEY);
      if (savedMode && Object.values(ScannerMode).includes(savedMode as ScannerMode)) {
        this.scannerMode = savedMode as ScannerMode;
      }

      setTimeout(() => {
        if (this.scannerMode === ScannerMode.Laser) {
          if (this.barcodeAutoComplete) {
            this.barcodeAutoComplete.instance.focus();
          }
        }
      }, 100);
  }

}
